import { Icon, Typography } from '@repo/ui';
import c from 'classnames';

import styles from './MarkedInSurveyBadge.module.css';

export const MARKED_IN_SURVEY_HOME_LABEL = 'Reported by you';
export const MARKED_IN_SURVEY_DETAIL_LABEL = 'Reported by you';

export const MarkedInSurveyBadge = ({
  label,
  className,
}: {
  label: string;
  className?: string;
}) => (
  <div className={c(styles.badge, className)}>
    <Icon name='flash2Filled' size='s' color='purple' />
    <Typography variant='caption' color='darkPurple' className={styles.label}>
      {label}
    </Typography>
  </div>
);

export default MarkedInSurveyBadge;
